import { createAsyncThunk } from '@reduxjs/toolkit'

import { getWithRetry } from '../../lib/api'
import { ConfigurationValue } from '../../types/Input'

export const getConfigurations = (): Promise<ConfigurationValue[]> => getWithRetry('configurations')

interface ConfigurationsError {
  message: string
}

export const fetchConfigurationsAction = createAsyncThunk<
  ConfigurationValue[],
  void,
  { rejectValue: ConfigurationsError }
>('configurations/fetchConfigurations', async (_, thunkApi) => {
  try {
    return await getConfigurations()
  } catch (err) {
    return thunkApi.rejectWithValue({
      message: 'Failed to fetch configurations from API',
    })
  }
})
